export const managedFarmFormSteps = {
  STEP1: 'step1',
  STEP2: 'step2',
  STEP3: 'step3',
  STEP4: 'step4',
};

interface IManagedFarmCheckpointByTaskType {
  placeholder: string;
  recommendedCheckpoint: string[];
}

export const managedFarmCheckpointByTaskType: Record<string, IManagedFarmCheckpointByTaskType> = {
  수확: {
    placeholder: '작업이 어려운 구간이 있다면 미리 알려주세요.',
    recommendedCheckpoint: [
      '돌, 기계 등 장애물은 미리 치워주시면 안전하게 작업할 수 있어요.',
      '벼가 도복(땅에 닿은 상태)된 경우엔 미리 알려주세요.',
      '벼멸구 피해가 있다면 미리 알려주세요.',
    ],
  },
  방제: {
    placeholder: '약제는 농민 분께서 준비해주시되, 반드시 무인항공기 전용으로 부탁드려요.',
    recommendedCheckpoint: [
      '전깃줄, 통신선, 철탑 등 드론에 위험한 요소는 꼭 사전에 알려주세요.',
      '인접 필지에 다른 작물, 양봉장, 친환경 단지, 수원, 축사 등이 있다면 꼭 알려주세요.',
      '목적, 약제명, 혼합/희석 여부도 알려주면 정확하게 도와드릴게요.',
    ],
  },
  조사료: {
    placeholder: '빠지는 구간은 미리 말씀해주세요.',
    recommendedCheckpoint: [
      '장애물이 있으면 사전에 정리 부탁드려요.',
      '볏짚, 콩대, 고춧대 등 잔여물이 많은 경우 작업이 어려울 수 있으니 미리 확인 부탁드려요.',
    ],
  },
  베일러: {
    placeholder: '집초 작업이 필요하시면 꼭 사전에 알려주세요.',
    recommendedCheckpoint: [
      '선 집초 작업은 필수입니다. 번거로우시겠지만 협조 부탁드립니다.',
      '래핑 작업이 필요하다면 미리 말씀해주세요.',
      '빠지는 구간은 미리 알려주시면 출장비가 발생하지 않아요.',
      '장애물은 작업 전에 정리해주시면 장비 손상을 막을 수 있어요.',
      '경사 구간이 있다면 가장 급한 곳의 경사도를 알려주세요. 안전에 꼭 필요한 정보입니다.',
    ],
  },
  래핑: {
    placeholder: '집초 작업이 필요하시면 꼭 사전에 알려주세요.',
    recommendedCheckpoint: [
      '선 집초 작업은 필수입니다. 번거로우시겠지만 협조 부탁드립니다.',
      '래핑 작업이 필요하다면 미리 말씀해주세요.',
      '빠지는 구간은 미리 알려주시면 출장비가 발생하지 않아요.',
      '장애물은 작업 전에 정리해주시면 장비 손상을 막을 수 있어요.',
      '경사 구간이 있다면 가장 급한 곳의 경사도를 알려주세요. 안전에 꼭 필요한 정보입니다.',
    ],
  },
  집게: {
    placeholder: '집초 작업이 필요하시면 꼭 사전에 알려주세요.',
    recommendedCheckpoint: [
      '선 집초 작업은 필수입니다. 번거로우시겠지만 협조 부탁드립니다.',
      '래핑 작업이 필요하다면 미리 말씀해주세요.',
      '빠지는 구간은 미리 알려주시면 출장비가 발생하지 않아요.',
      '장애물은 작업 전에 정리해주시면 장비 손상을 막을 수 있어요.',
      '경사 구간이 있다면 가장 급한 곳의 경사도를 알려주세요. 안전에 꼭 필요한 정보입니다.',
    ],
  },
  기타: {
    placeholder: '집초 작업이 필요하시면 꼭 사전에 알려주세요.',
    recommendedCheckpoint: [
      '선 집초 작업은 필수입니다. 번거로우시겠지만 협조 부탁드립니다.',
      '래핑 작업이 필요하다면 미리 말씀해주세요.',
      '빠지는 구간은 미리 알려주시면 출장비가 발생하지 않아요.',
      '장애물은 작업 전에 정리해주시면 장비 손상을 막을 수 있어요.',
      '경사 구간이 있다면 가장 급한 곳의 경사도를 알려주세요. 안전에 꼭 필요한 정보입니다.',
    ],
  },
  추비: {
    placeholder: '비료의 종류(상표명)을 알려주세요.',
    recommendedCheckpoint: [
      '뿌리고자 하는 총 비료의 양을 알려주세요.',
      '시비 방법을 알려주세요. (골뿌림, 구멍시비, 관주 시비, 엽면 시비)',
      '북주기/배토, 김매기를 함께 진행할 것인지 알려주세요.',
    ],
  },
  파종: {
    placeholder: '종자(품종명이나 종자 봉투)를 꼭 알려주세요.',
    recommendedCheckpoint: [
      '종자는 고객님이 준비해주세요.',
      '물빠짐 상태와 자갈 유무를 꼭 알려주세요.',
      '친환경/유기농일시 알려주세요.',
      '사용할 비료(유기질 비료, 복한 비료)를 알려주세요.',
      '밑거름 살포나 경운, 로타리 작업이 포함되는지 알려주세요.',
      '멀칭 비닐을 미리 준비해 주세요.',
      '줄 간격(cm), 포기 간격(cm) 수치로 알려주세요.',
      '씨앗 파종 깊이와 구멍당 넣을 씨앗의 수를 알려주세요.',
    ],
  },
  경운: {
    placeholder: '빠지는 구간은 꼭 미리 알려주셔요.',
    recommendedCheckpoint: [
      '필요한 작업과 횟수를 알려주세요.(쟁기,로터리,두둑)',
      '희망하는 깊이를 알려주세요.',
      '토성(진흙밭, 모래밭) 알려주세요.',
      '돌, 자갈 유무를 알려주세요.',
      '지하 매설물(수도관, 파이프, 전기선) 꼭 알려주세요.',
      '밑거름(살포) 필요하면 말씀주세요.',
    ],
  },
};
